import React, { Component } from 'react';
import { DASHBOARD_SCREEN } from '../../global/Constants';
import { DashboardType } from '../../global/Enum';
//import Utilities from '../../global/Utilities';


class DashboardActivity extends Component {
    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {
        //this.getBarHeightValue(50);
    }

    getIVMaxValue() {
        const individualVisit = this.props.activities?.individual_visit;
        let maxValue = Math.max.apply(Math, individualVisit.sub_activity.map(function (user) {
            return user.completed_activity;
        }))
        return maxValue;
    }

    getWidthIVSubActivity(completed) {
        const totalWidth = (completed * 100) / this.getIVMaxValue();
        return totalWidth + "%";
    }

    getActiveValue(max, active) {
        //const { total, achieve } = this.props;
        const percent = (active * 100) / max;
        return Math.round(percent) + "%";
    }

    getPendingValue(max, active) {
        //const { total, achieve } = this.props;
        const percent = (active * 100) / max;
        return Math.round(100 - percent) + "%";
    }


    getActivitiesPercent() {
        const { activities } = this.props;
        let total = activities.total_activity;
        if (total > 0) {
            let completed = activities.completed_activity;
            const percent = (completed * 100) / total;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }


    getTotalHeightMaxValue() {
        const { activities } = this.props;
        return Math.max(activities.individual_visit.total_activity,
            activities.sample_distribution.total_activity,
            activities.group_meeting.total_activity,
            activities.sample_to_sale.total_activity);
    }

    getBarHeightValue(total) {
        if (total > 0) {
            const height = (total * 100) / this.getTotalHeightMaxValue();
            return Math.round(height) + "%";
        } else {
            return 0 + "%";
        }
    }

    getFilledBarPercent(totalActivity, completedActivity) {
        const percent = (completedActivity * 100) / totalActivity;
        //Utilities.LogPrint("Filled", Math.round(percent) + "%");
        return Math.round(percent) + "%";
    }

    getUnFilledBarPercent(totalActivity, completedActivity) {
        const percent = (completedActivity * 100) / totalActivity;
        return Math.round(100 - percent) + "%";
    }


    render() {
        const { activities, activeTab } = this.props;
        const individualVisit = activities?.individual_visit;
        const sampleDistribution = activities?.sample_distribution;
        const groupMeeting = activities?.group_meeting;
        const sampleToSale = activities?.sample_to_sale;


        if (individualVisit && sampleDistribution && groupMeeting && sampleToSale) {
            return (
                <div id="activities" className={activeTab === DashboardType.ACTIVITIES ? "more-menu-body" : "d-none"}>
                    <h6 className="font-weight-medium d-flex">{DASHBOARD_SCREEN.ACTIVITIES_COMPLETED}
                        <span className="ml-auto">{activities.completed_activity}/{activities.total_activity}</span></h6>
                    <div className="progress progress-red1 mb-3">
                        <div className={`progress-bar ${activities?.completed_activity === 0 ? "progress-padding" : ''} `} role="progressbar" style={{ width: this.getActivitiesPercent() }}
                            aria-valuemax="100">{this.getActivitiesPercent()}
                        </div>
                    </div>

                    {/* Activite Chart */}
                    <div className="gray-bg bdr-radius-7" id="activiteAccordion">
                        <div className="activite-chart d-flex">
                            <ul className="custom-bar-chart">
                                <li>
                                    {/* {
                                        individualVisit.total_activity === individualVisit.completed_activity ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(individualVisit.total_activity)} + 33px)` }}>{individualVisit.total_activity}</span> : null
                                    } */}

                                    {
                                        individualVisit.total_activity === 0 ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(individualVisit.total_activity)} + 33px)` }}>{individualVisit.total_activity}</span> :
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(individualVisit.total_activity)} + 33px)` }}>{individualVisit.completed_activity} / {individualVisit.total_activity}</span>
                                    }

                                    {/* <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(individualVisit.total_activity)} + 33px)` }}>{individualVisit.completed_activity} / {individualVisit.total_activity}</span> */}
                                    <div className="full-bar" style={{ height: this.getBarHeightValue(individualVisit.total_activity) }} data-toggle="collapse" data-target="#collapseIV" >
                                        <div className="total-bar" style={{ height: this.getUnFilledBarPercent(individualVisit.total_activity, individualVisit.completed_activity) }}>
                                            {/* {individualVisit.total_activity} */}
                                        </div>
                                        <div className="sun-total-bar yellow-activity" style={{ height: this.getFilledBarPercent(individualVisit.total_activity, individualVisit.completed_activity) }}>
                                            {/* {individualVisit.completed_activity} */}
                                        </div>
                                    </div>
                                    <div className="bar-title w-100">IV</div>
                                </li>
                                <li>
                                    {/* {
                                        sampleDistribution.total_activity === sampleDistribution.completed_activity ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleDistribution.total_activity)} + 33px)` }}>{sampleDistribution.total_activity}</span> : null
                                    } */}

                                    {
                                        sampleDistribution.total_activity === 0 ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleDistribution.total_activity)} + 33px)` }}> {sampleDistribution.total_activity}</span> :
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleDistribution.total_activity)} + 33px)` }}>{sampleDistribution.completed_activity} / {sampleDistribution.total_activity}</span>
                                    }

                                    {/* <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleDistribution.total_activity)} + 33px)` }}>{sampleDistribution.completed_activity} / {sampleDistribution.total_activity}</span> */}
                                    <div className="full-bar" style={{ height: this.getBarHeightValue(sampleDistribution.total_activity) }} data-toggle="collapse" data-target="#collapseSD" aria-expanded="false" aria-controls="collapseSD">
                                        <div className="total-bar" style={{ height: this.getUnFilledBarPercent(sampleDistribution.total_activity, sampleDistribution.completed_activity) }}>
                                            {/* {sampleDistribution.total_activity} */}
                                        </div>
                                        <div className="sun-total-bar brown-activity" style={{ height: this.getFilledBarPercent(sampleDistribution.total_activity, sampleDistribution.completed_activity) }}>
                                            {/* {sampleDistribution.completed_activity} */}
                                        </div>
                                    </div>
                                    <div className="bar-title w-100">SD</div>
                                </li>
                                <li>
                                    {/* {
                                        groupMeeting.total_activity === groupMeeting.completed_activity ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(groupMeeting.total_activity)} + 33px)` }}>{groupMeeting.total_activity}</span> : null
                                    } */}
                                    {
                                        groupMeeting.total_activity === 0 ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(groupMeeting.total_activity)} + 33px)` }}> {groupMeeting.total_activity}</span> :
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(groupMeeting.total_activity)} + 33px)` }}>{groupMeeting.completed_activity} / {groupMeeting.total_activity}</span>
                                    }
                                    {/* <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(groupMeeting.total_activity)} + 33px)` }}>{groupMeeting.total_activity}</span> */}
                                    <div className="full-bar" style={{ height: this.getBarHeightValue(groupMeeting.total_activity) }} data-toggle="collapse" data-target="#collapseGM" aria-expanded="false" aria-controls="collapseGM">
                                        <div className="total-bar" style={{ height: this.getUnFilledBarPercent(groupMeeting.total_activity, groupMeeting.completed_activity) }}>
                                            {/* {groupMeeting.total_activity} */}
                                        </div>
                                        <div className="sun-total-bar blue-activity" style={{ height: this.getFilledBarPercent(groupMeeting.total_activity, groupMeeting.completed_activity) }}>
                                            {/* {groupMeeting.completed_activity} */}
                                        </div>
                                    </div>
                                    <div className="bar-title w-100">GM</div>
                                </li>
                                <li>
                                    {/* <span className="small-bar-outertext" style={{ bottom: 'calc(10% + 33px)' }}>5</span> */}
                                    {/* {
                                        sampleToSale.total_activity === sampleToSale.completed_activity ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleToSale.total_activity)} + 33px)` }}>{sampleToSale.total_activity}</span> : null
                                    } */}

                                    {
                                        sampleToSale.total_activity === 0 ?
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleToSale.total_activity)} + 33px)` }}>{sampleToSale.total_activity}</span> :
                                            <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleToSale.total_activity)} + 33px)` }}>{sampleToSale.completed_activity} / {sampleToSale.total_activity}</span>
                                    }

                                    {/* <span className="small-bar-outertext" style={{ bottom: `calc(${this.getBarHeightValue(sampleToSale.total_activity)} + 33px)` }}>{sampleToSale.completed_activity} / {sampleToSale.total_activity}</span> */}
                                    <div className="full-bar" style={{ height: this.getBarHeightValue(sampleToSale.total_activity) }} data-toggle="collapse" data-target="#collapseS2S" aria-expanded="false" aria-controls="collapseS2S">
                                        <div className="total-bar" style={{ height: this.getUnFilledBarPercent(sampleToSale.total_activity, sampleToSale.completed_activity) }}>
                                            {/* {sampleToSale.total_activity} */}
                                        </div>
                                        <div className="sun-total-bar green-activity" style={{ height: this.getFilledBarPercent(sampleToSale.total_activity, sampleToSale.completed_activity) }}>
                                            {/* {sampleToSale.completed_activity} */}
                                        </div>
                                    </div>
                                    <div className="bar-title w-100">S2S</div>
                                </li>

                            </ul>
                        </div>

                        {/* {
                            individualVisit.sub_activity?.length > 0 ?
                                this.showIVSubActivity(individualVisit.sub_activity) : null
                        }

                        {
                            sampleDistribution.sub_activity?.length > 0 ?
                                this.showSDSubActivity(sampleDistribution.sub_activity) : null
                        }

                        {
                            groupMeeting.sub_activity?.length > 0 ?
                                this.showGMSubActivity(groupMeeting.sub_activity) : null
                        }

                        {
                            sampleToSale.sub_activity?.length > 0 ?
                                this.showS2SSubActivity(sampleToSale.sub_activity) : null
                        } */}

                        {this.showIVSubActivity(individualVisit.sub_activity)}
                        {this.showSDSubActivity(sampleDistribution.sub_activity)}
                        {this.showGMSubActivity(groupMeeting.sub_activity)}
                        {this.showS2SSubActivity(sampleToSale.sub_activity)}
                    </div>
                </div>
            )
        } else {
            return null;
        }
    }

    showIVSubActivity = (subActivities) => {
        return (
            <div className="collapse px-0 px-md-3" id="collapseIV" data-parent="#activiteAccordion">
                <div className="row">
                    <div className="col-12">
                        {
                            subActivities.length ?
                                <h6 className="font-weight-medium text-white">Individual Activities by Sub-Activities</h6> :
                                <h6 className="font-weight-medium text-white">No Sub-Activities Found!</h6>
                        }

                    </div>
                </div>
                <div className="row mt-3">

                    {
                        subActivities.length ?
                            subActivities.map((item, i) => (
                                <div className="col-12 mb-3" key={i}>
                                    <div className="row align-items-center">
                                        <div className="col-4 col-md-3 text-right"><label className="mb-0 text-white">{item.activity_name}</label></div>
                                        <div className="col-8 col-md-9 pl-0">
                                            <div className="progress double-progress-bar">
                                                {/* <div className="progress-bar yellow-activity sub-activity-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getWidthIVSubActivity(item.completed_activity) }}>{item.completed_activity}</div> */}

                                                {/* <div className="progress-bar yellow-activity sub-activity-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity) }}>{item.completed_activity}</div> */}
                                                {/* <div className="progress-bar bg-white d-none" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getPendingValue(item.total_activity, item.completed_activity) }}></div> */}
                                                {/* <div className={`progress-bar bg-white ${item.total_activity === item.completed_activity ? 'd-none' : ''}`} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getPendingValue(item.total_activity, item.completed_activity) }}>
                                                    {item.total_activity}
                                                </div> */}

                                                <div className={`progress-bar yellow-activity ${item?.completed_activity === 0 ? 'progress-padding' : ''}`} role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity) }}>{item.completed_activity}</div>
                                                <div className={`progress-bar bg-white ${item?.completed_activity === item.total_activity ? 'd-none' : ''}`} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getPendingValue(item.total_activity, item.completed_activity) }}></div>
                                                <span className={item?.completed_activity === item.total_activity ? 'd-none' : ''}>{item.total_activity}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )) : null
                    }

                    {/* <div className="col-12 mb-3">
                        <div className="row align-items-center">
                            <div className="col-4 col-md-2 text-right"><label className="mb-0 text-white">Sub Activity</label></div>
                            <div className="col-8 col-md-10 pl-0">
                                <div className="progress double-progress-bar">
                                    <div className="progress-bar yellow-activity" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: "85%" }}>9</div>
                                    <div className="progress-bar bg-white" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: "15%" }}>10</div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                </div>
            </div>
        )

    }

    showSDSubActivity = (subActivities) => {
        return (
            <div className="collapse px-0 px-md-3" id="collapseSD" data-parent="#activiteAccordion">
                <div className="row">
                    <div className="col-12">
                        {
                            subActivities.length ?
                                <h6 className="font-weight-medium text-white">Sample Distribution by Sub-Activities</h6> :
                                <h6 className="font-weight-medium text-white">No Sub-Activities Found!</h6>
                        }
                    </div>
                </div>
                <div className="row mt-3">
                    {
                        subActivities.length ?
                            subActivities.map((item, i) => (
                                <div className="col-12 mb-3" key={i}>
                                    <div className="row align-items-center">
                                        <div className="col-4 col-md-3 text-right"><label className="mb-0 text-white">{item.activity_name}</label></div>
                                        <div className="col-8 col-md-9 pl-0">
                                            <div className="progress double-progress-bar">
                                                <div className={`progress-bar brown-activity ${item?.completed_activity === 0 ? 'progress-padding' : ''}`} role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity) }}>{item.completed_activity}</div>
                                                <div className={`progress-bar bg-white ${item?.completed_activity === item.total_activity ? 'd-none' : ''}`} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getPendingValue(item.total_activity, item.completed_activity) }}></div>
                                                <span className={item?.completed_activity === item.total_activity ? 'd-none' : ''}>{item.total_activity}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )) : null
                    }

                </div>
            </div>
        )
    }

    showGMSubActivity = (subActivities) => {
        return (
            <div className="collapse px-0 px-md-3" id="collapseGM" data-parent="#activiteAccordion">
                <div className="row">
                    <div className="col-12">
                        {
                            subActivities.length ?
                                <h6 className="font-weight-medium text-white">Group Meeting by Sub-Activities</h6> :
                                <h6 className="font-weight-medium text-white">No Sub-Activities Found!</h6>
                        }

                    </div>
                </div>
                <div className="row mt-3">
                    {
                        subActivities.length ?
                            subActivities.map((item, i) => (
                                <div className="col-12 mb-3" key={i}>
                                    <div className="row align-items-center">
                                        <div className="col-4 col-md-3 text-right"><label className="mb-0 text-white">{item.activity_name}</label></div>
                                        <div className="col-8 col-md-9 pl-0">
                                            <div className="progress double-progress-bar">
                                                <div className={`progress-bar blue-activity ${item?.completed_activity === 0 ? 'progress-padding' : ''}`} role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity) }}>{item.completed_activity}</div>
                                                <div className={`progress-bar bg-white ${item?.completed_activity === item.total_activity ? 'd-none' : ''}`} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getPendingValue(item.total_activity, item.completed_activity) }}></div>
                                                <span className={item?.completed_activity === item.total_activity ? 'd-none' : ''}>{item.total_activity}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )) : null
                    }

                </div>
            </div>
        )
    }

    showS2SSubActivity = (subActivities) => {
        //const { activities } = this.state;
        return (
            <div className="collapse px-0 px-md-3" id="collapseS2S" data-parent="#activiteAccordion">
                <div className="row">
                    <div className="col-12">
                        {/* <h6 className="font-weight-medium text-white">Sample To Sale by Sub-Activities</h6> */}
                        {
                            subActivities.length ?
                                <h6 className="font-weight-medium text-white">Sample To Sale by Sub-Activities</h6> :
                                <h6 className="font-weight-medium text-white">No Sub-Activities Found!</h6>
                        }
                    </div>
                </div>
                <div className="row mt-3">
                    {
                        subActivities.length ?
                            subActivities.map((item, i) => (
                                <div className="col-12 mb-3" key={i}>
                                    <div className="row align-items-center">
                                        <div className="col-4 col-md-3 text-right"><label className="mb-0 text-white">{item.activity_name}</label></div>
                                        <div className="col-8 col-md-9 pl-0">
                                            <div className="progress double-progress-bar">
                                                {/* <div className="progress-bar green-activity" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity) }}>{item.completed_activity}</div>
                                                <div className="progress-bar bg-white" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getPendingValue(item.total_activity, item.completed_activity) }}></div> */}

                                                <div className={`progress-bar green-activity ${item?.completed_activity === 0 ? 'progress-padding' : ''}`} role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity) }}>{item.completed_activity}</div>
                                                <div className={`progress-bar bg-white ${item?.completed_activity === item.total_activity ? 'd-none' : ''}`} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: this.getPendingValue(item.total_activity, item.completed_activity) }}></div>
                                                <span className={item?.completed_activity === item.total_activity ? 'd-none' : ''}>{item.total_activity}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )) : null
                    }

                </div>
            </div>
        )
    }
}

export default DashboardActivity;
